// Compliance notes on a product page (owner, 2026-11-02 — PRICING_PLAN §2.3). The price
// stays visible; the note says a certificate MAY be needed, that we check before buying
// from the factory, and that the trader can still cancel for a full refund. The Arabic
// is the owner's text, word for word. Which notes a product carries comes from the server
// (market_delivered → compliance: rules + a staff override); the SABER note shows only
// from saber_note_min_qty pieces (0 = always). App twin: src/lib/market/marketCompliance.js.

export const COMPLIANCE_T = {
  ar: {
    saberTitle: '⚠️ ملاحظة عن شهادة المطابقة (سابر)',
    saber: 'هذا المنتج قد يحتاج شهادة سابر عند استيراده بكميات تجارية. الطلبات الشخصية بكمية صغيرة لا تحتاجها غالبًا.\nنتحقق من ذلك قبل شراء طلبك من المصنع. وإذا احتاج طلبك شهادة، نبلغك بتكلفتها قبل أي خطوة، ولك الخيار تكمل أو تلغي وتسترد مبلغك كامل.',
    sfda: '⚠️ هذا المنتج قد يحتاج تسجيل لدى هيئة الغذاء والدواء. نتحقق من ذلك قبل شراء طلبك من المصنع. وإذا احتاج طلبك تسجيل، نبلغك بتكلفته قبل أي خطوة، ولك الخيار تكمل أو تلغي وتسترد مبلغك كامل.',
    cst: '⚠️ هذا المنتج قد يحتاج اعتماد هيئة الاتصالات والفضاء والتقنية. نتحقق من ذلك قبل شراء طلبك من المصنع. وإذا احتاج طلبك اعتماد، نبلغك بتكلفته قبل أي خطوة، ولك الخيار تكمل أو تلغي وتسترد مبلغك كامل.',
  },
  en: {
    saberTitle: '⚠️ About the conformity certificate (SABER)',
    saber: 'This product may need a SABER certificate when imported in commercial quantities. Small personal orders usually do not.\nWe check this before buying your order from the factory. If your order needs a certificate, we tell you its cost before any step, and you choose to continue or cancel with a full refund.',
    sfda: '⚠️ This product may need registration with the Saudi Food and Drug Authority (SFDA). We check this before buying your order from the factory. If your order needs registration, we tell you its cost before any step, and you choose to continue or cancel with a full refund.',
    cst: '⚠️ This product may need approval from the Communications, Space and Technology Commission (CST). We check this before buying your order from the factory. If your order needs approval, we tell you its cost before any step, and you choose to continue or cancel with a full refund.',
  },
  zh: {
    saberTitle: '⚠️ 关于符合性证书（SABER）',
    saber: '本产品以商业数量进口时可能需要 SABER 证书。小批量个人订单通常不需要。\n我们会在向工厂采购您的订单之前核实。如果您的订单需要证书，我们会在任何步骤之前告知费用，您可以选择继续，或取消并全额退款。',
    sfda: '⚠️ 本产品可能需要在沙特食品药品管理局（SFDA）注册。我们会在向工厂采购您的订单之前核实。如果您的订单需要注册，我们会在任何步骤之前告知费用，您可以选择继续，或取消并全额退款。',
    cst: '⚠️ 本产品可能需要沙特通信、航天与技术委员会（CST）的认证。我们会在向工厂采购您的订单之前核实。如果您的订单需要认证，我们会在任何步骤之前告知费用，您可以选择继续，或取消并全额退款。',
  },
};

/** The notes to show for a product at a quantity: [{ key, title?, text }] in a fixed order. */
export function complianceNotes(info, qty, cfg, lang) {
  const c = info?.compliance;
  if (!c) return [];
  const t = COMPLIANCE_T[lang] || COMPLIANCE_T.ar;
  const minQty = Number(cfg?.saber_note_min_qty) || 0;
  const out = [];
  if (c.saber === true && (minQty === 0 || Number(qty) >= minQty)) out.push({ key: 'saber', title: t.saberTitle, text: t.saber });
  if (c.sfda === true) out.push({ key: 'sfda', text: t.sfda });
  if (c.cst === true) out.push({ key: 'cst', text: t.cst });
  return out;
}
